import { login, getLoginUser, logout } from '@/api/users'
import { lczOALogin } from '@/api/lcz'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    loginState:null,
    auth:null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.loginState = user;
      state.auth=user.auth;
     // Object.assign(state.user, user)
    }
  },

  actions: {
    // 
    wxlogin({ commit }, token) {
      //const username = userInfo.username.trim()
      setToken(token)
      commit('SET_TOKEN', token)
      return new Promise((resolve, reject) => {
        resolve()
      })
    },    
    // 登录
    login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          if (response.status == 0) {
            const token = response.data
            setToken(token)
            commit('SET_TOKEN', token)
            resolve()
            // commit('SET_USER', data)
          } else {
            reject(response.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    oaLogin({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        lczOALogin({ username: username, password: userInfo.password }).then(response => {
          if (response.status == 0) {
            const token = response.data
            setToken(token)
            commit('SET_TOKEN', token)
            resolve()
          } else {
            reject(response.msg || response.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    getLoginUser({ commit }) {
      return new Promise((resolve, reject) => {
        getLoginUser().then(response => {
          const data = response.data
          commit('SET_USER', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js